// This streamlines the file upload where users can click a single button to
// trigger a file input and submit the form.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "input", "form", "csvFileLoading"]

  trigger() {
    this.inputTarget.click()
  }

  connect() {
    this.turboSubmitEndHandler = () => {
      // Optional usage if we want to disable the button while file is uploading
      if (this.hasButtonTarget) {
        this.buttonTarget.disabled = false
        this.buttonTarget.classList.remove("opacity-50", "cursor-not-allowed")
      }

      // Optional usage if a loading partial is shown while file is uploading
      if (this.hasCsvFileLoadingTarget) {
        this.csvFileLoadingTarget.classList.add("hidden")
      }
    }

    document.addEventListener("turbo:submit-end", this.turboSubmitEndHandler)
  }

  disconnect() {
    document.removeEventListener("turbo:submit-end", this.turboSubmitEndHandler)
  }


  submit() {
    if (this.hasButtonTarget) {
      // Disable the button
      this.buttonTarget.disabled = true
      this.buttonTarget.classList.add("opacity-50", "cursor-not-allowed")
    }

    if (this.hasCsvFileLoadingTarget) {
      this.csvFileLoadingTarget.classList.remove("hidden")
    }
    this.formTarget.requestSubmit()
  }
}
